import { render } from "./SignOutModal.vue?vue&type=template&id=3c115582&ts=true"
import script from "./SignOutModal.vue?vue&type=script&lang=ts"
export * from "./SignOutModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/marvin/go/src/github.com/emvi/lernapp-prototype/app/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__